var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCallUs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 49,
    viewBox: "0 0 50 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.8231 10.9599L11.4474 3.62031C10.5489 2.72627 9.09576 2.7323 8.21027 3.63917C6.62196 5.26585 4.22868 7.74075 2.79362 9.33785C0.35564 12.0511 10.234 26.7191 16.0104 32.1841C21.7868 37.649 36.7456 49.7259 40.1043 46.4434C41.5485 45.032 44.0485 42.5649 45.6979 40.9351C46.6024 40.0414 46.6036 38.583 45.7023 37.686L38.7807 30.7979C37.8982 29.9196 36.476 29.9072 35.5826 30.7743C34.8968 31.4398 34.0961 32.2206 33.3991 32.9094C33.0232 33.281 32.5315 33.5352 32.0103 33.4467C27.1628 32.6236 16.9404 21.9463 16.0561 17.7947C15.9533 17.3117 16.1988 16.8518 16.5472 16.5018C17.281 15.7643 18.1256 14.9097 18.8398 14.1854C19.7237 13.2892 19.7153 11.8478 18.8231 10.9599Z",
    stroke: "white",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5859 22.1921C47.5859 11.0403 38.5456 2 27.3938 2",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.1552 22.088C39.1552 15.5924 33.8894 10.3266 27.3938 10.3266",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallUs);
export default __webpack_public_path__ + "static/media/call-us.f8ed9ce338fa5314dee4976046dccff7.svg";
export { ForwardRef as ReactComponent };